export const posts = [
  {
    slug: "Debord is Online",
    href: "/zines/debord",
    title: "Debord is Online",
    excerpt: "Be the freak you wanna see. Just don't follow me.",
    type: "Essay / Zine",
    date: "October 8, 2026",
    categories: ["politics", "literature"],
    intersections: ["politics-literature"],
    content: [
      "Zine/Essay exploring the work of Guy Debord and the Situationist International, and how their ideas can be applied to contemporary life.",
    ],
  },
  {
    slug: "hyper-necropolis",
    href: "/essays/hyper-necropolis",
    title: "Hyper Necropolis and Digital Hauntology",
    excerpt: "The internet as a digital city of the dead.",
    type: "Essay",
    date: "August 10, 2026",
    categories: ["cybernetics", "literature"],
    intersections: ["cybernetics-literature"],
    content: [],
  },
  {
    slug: "songs-for-collapsing-futures",
    title: "Songs for Collapsing Futures",
    excerpt: "",
    type: "Review / Essay",
    date: "March 2026",
    categories: ["music", "literature", "cybernetics"],
    intersections: ["cybernetics-literature", "music-literature"],
    content: [
      "",
    ],
  },
];